<cm-infinite-list [count]="$totalCount()" [intersectionStatusChange]="$pageFilledStatusChange()" class="cm-items-list">
    <cm-list-info cm-list-header [parentList]="this" [stateLabels]="$stateLabels()" [count]="$totalCount()"></cm-list-info>

    @for (item of $items(); track item.trackId) {
        @if (item.data; as template) {
            <cm-entity-card
                @fadeInCard
                [entity]="template"
                [entityLink]="templateLink(template)"
                [entityQueryParamsHandling]="'preserve'"
                [multiThumbnailIds]="multiThumbnailIds(template)"
                [disabled]="!templateLink(template)"
            >
                <ng-container cm-top-left>
                    <div (click)="$event.stopPropagation()" class="cm-action-container">
                        <a [routerLink]="['./', template.id]" queryParamsHandling="preserve" class="cm-action-icon-container">
                            <i class="far fa-circle-info cm-action-icon" [matTooltip]="'Show ' + $entityName() + ' details'"></i>
                        </a>
                        @if ($can().copy.template(template)) {
                            <a (click)="copyTemplate(template)" class="cm-action-icon-container">
                                <i class="far fa-copy cm-action-icon" matTooltip="Make a copy"></i>
                            </a>
                        }
                    </div>
                </ng-container>
                <ng-container cm-bottom-left>
                    @if ($can().read.template(template, "paymentState")) {
                        <cm-payment-state-label
                            [item]="{id: template.id, __typename: 'Template', organization: {id: template.organization.id, __typename: 'Organization'}}"
                            [editable]="$can().update.template(template, 'paymentState')"
                            (stateChange)="updateItem({id: template.id, paymentState: $event})"
                        ></cm-payment-state-label>
                    }
                    @if ($can().update.template(template, "state")) {
                        <cm-state-label
                            [stateLabels]="Labels.TemplateState"
                            [state]="template.state"
                            [editable]="$can().update.template(template, 'state')"
                            (stateChange)="updateItem({id: template.id, state: $event})"
                        ></cm-state-label>
                    } @else {
                        <cm-state-label [stateLabels]="Labels.TemplateState" [state]="template.state"></cm-state-label>
                    }
                </ng-container>
            </cm-entity-card>
        } @else if (item.placeholder) {
            <cm-card-placeholder @fadeInPlaceholder></cm-card-placeholder>
        } @else {
            <cm-card-error @fadeInPlaceholder></cm-card-error>
        }
    }
</cm-infinite-list>
